import type { ReactNode } from "react";
import { cn } from "@/shared/lib/utils";

interface EnterpriseEmptyStateProps {
    icon?: ReactNode;
    title: string;
    description?: string;
    action?: ReactNode;
    className?: string;
}

export function EnterpriseEmptyState({
    icon,
    title,
    description,
    action,
    className,
}: EnterpriseEmptyStateProps) {
    return (
        <div
            className={cn(
                "flex min-h-32 flex-col items-center justify-center rounded-xl border border-dashed border-border/70 bg-muted/30 p-6 text-center",
                className,
            )}
        >
            {icon ? <div className="mb-3 text-muted-foreground/80">{icon}</div> : null}
            <p className="text-sm font-medium text-foreground">{title}</p>
            {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
            {action ? <div className="mt-4">{action}</div> : null}
        </div>
    );
}
